<div class="pop-bg">
</div>
<div class="pop-position">
    <div class="row">
        <div class="row p-0 grey">
            <span class="col-md-10 col-sm-10 p-0">
                <div class="heading-panel sT-hight pl-10">
                    <span class="text-sm text-ellipsis heading-txt flex">Account List</span>
                </div>
            </span>
            <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="Close()">
                <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </div>
        <div class="col-md-12 p-0">
            <div class="sticky-table sticky-ltr-cells border-0 table-hight popup-table-height">
                <table class="table">
                    <thead>
                        <tr class="sticky-header">
                            <th>Payer Name</th>
                            <th>TFL Stats</th>
                            <th>Days</th>
                            <th>Amount ($)</th>
                            <th>V/N</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td class="tr-active">UHC MCAID STAR</td>
                            <td class="tr-active">NTFL</td>
                            <td class="tr-active">4</td>
                            <td class="tr-active">$ 569.26</td>
                            <td class="tr-active">Non-Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Non-Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Non-Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                        <tr>
                            <td>UHC MCAID STAR</td>
                            <td>NTFL</td>
                            <td>4</td>
                            <td>$ 569.26</td>
                            <td>Voice</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>